module.exports = __webpack_public_path__ + "media/images/bg/shapes/media-dac1430619fce224d28b3d46a801354e.svg";